import { ADMIN_API } from "./adminApi";
import { ApiOk, Paginated } from "./adminCommon.types";

export type IntegrationState = "operational" | "maintenance" | "instability";

export type AdminIntegrationStatus = {
  key: string;
  label: string;
  state: IntegrationState;
  message: string | null;
  responseTimeMs: number | null;
  lastSync: string | null;
  errorCount24h: number;
  totalChecks24h: number;
  updatedAt: string;
};

export const getIntegracoesStatus = async () => {
  const { data } = await ADMIN_API.get<ApiOk<AdminIntegrationStatus[]>>("/api/admin/integracoes/status");
  return data.data;
};

export const setIntegracaoStatus = async (key: string, state: IntegrationState, message?: string) => {
  const { data } = await ADMIN_API.put<ApiOk<any>>(`/api/admin/integracoes/${key}/status`, { state, message });
  return data.data;
};

export const getIntegracoesLogs = async (params: Record<string, any> = {}) => {
  const { data } = await ADMIN_API.get<Paginated<any>>("/api/admin/integracoes/logs", { params });
  return data;
};

export const testarAlertaSlack = async () => {
  const { data } = await ADMIN_API.post<ApiOk<null>>("/api/admin/integracoes/testar-alerta");
  return data;
};
